/**
 * @format
 * @module lib/commercial/dfp-ads/size-mapping
 * @description All adslot size mappings.
 */
import mergeWith from "lodash/mergeWith";
import { arrayMerge } from "utils/utils";
import advInteractiveArticle from "./categories/adv-interactive-article";
import advStandardArticle from "./categories/adv-standard-article";
import anonSuperHeroSizes from "./categories/anon-super-hero-sizes";
import electionResultsPage from "./categories/election-results-page";
import financialPage from "./categories/financial-page";
import financialPageFullChart from "./categories/financial-page-fullchart";
import financialPageWatchlist from "./categories/financial-page-watchlist";
import homePage from "./categories/home-page";
import interactiveArticle from "./categories/interactive-article";
import longReadArticle from "./categories/longread-article";
import noAds from "./categories/no-ads-except-hidden";
import video from "./categories/video";
import premiumArticle from "./categories/premium-article";
import premiumSection from "./categories/premium-section";
import premiumSectionInvesting from "./categories/premium-section-investing";
import premiumSectionInvestingTest from "./categories/premium-section-investing-test";
import videoSponsored from "./categories/video-sponsored";
import videoSponsoredKeyword from "./categories/video-sponsored-keyword";
import standardArticle from "./categories/standard-article";
import standardSection from "./categories/standard-section";
import staticWithRail from "./categories/static-with-rail";
import staticWithoutRail from "./categories/static-without-rail";

// Extends longReadArticle - Anonymous long read article page
const anonLongReadArticle = mergeWith({}, longReadArticle, anonSuperHeroSizes, arrayMerge);

// Extends premiumArticle - Anonymous premium article page
const anonPremiumArticle = mergeWith({}, premiumArticle, anonSuperHeroSizes, arrayMerge);

// Extends standardArticle - Anonymous standard article page
const anonStandardArticle = mergeWith({}, standardArticle, anonSuperHeroSizes, arrayMerge);

// Extends premiumSection - Anonymous premium section page
const anonPremiumSection = mergeWith({}, premiumSection, anonSuperHeroSizes, arrayMerge);

// Extends standardSection - Anonymous standard section page
const anonStandardSection = mergeWith({}, standardSection, anonSuperHeroSizes, arrayMerge);

// The ad guidelines sizes for different sections and pages.
const sizes = {
  homePage, // Page that uses PB "homepage" layout
  videoSponsoredKeyword, // Sponsored video page (with special meta keyword)
  videoSponsored, // Sponsored video page (without special meta keyword)
  video, // Non-sponsored (regular) video article page
  anonLongReadArticle, // Anonymous long read article page
  longReadArticle, // Long read article page
  anonPremiumArticle, // Anonymous premium article page
  premiumArticle, // Premium article page
  advInteractiveArticle, // ADV interactive article page
  interactiveArticle, // Interactive article page
  advStandardArticle, // ADV content article
  anonStandardArticle, // Anonymous standard article page
  standardArticle, // Standard article page
  financialPageWatchlist, // Financial Watchlist section page
  financialPageFullChart, // Financial Full-chart section page
  financialPage, // Financial section or leaf page
  noAds, // No ads (except for the hidden "html" slot)
  electionResultsPage, // Elections Results page
  premiumSectionInvestingTest, // Premium Investing section "test" page
  premiumSectionInvesting, // Premium Investing section page
  anonPremiumSection, // Anonymous premium article page
  premiumSection, // Premium section page
  anonStandardSection, // Anonymous standard section page
  standardSection, // Standard section page
  static: staticWithoutRail, // Static page - no right-rail
  static2: staticWithRail // Static page - yes right-rail
};

export default sizes;
